module.exports = __webpack_public_path__ + "media/beep-short.6bb58878.wav";